interface Colors {
  bgColorBlack: string;
  bgColorBordeaux: string;
  bgColorRed: string;
  bgColorBlack2: string;
  bgColorLight: string;
  bgSfondoColor: string;
  bgGradientSfondoColor: string;
  bgColorSfondoWinner: string;
  gradientBordeauxToBlack2: string;
  gradientWhiteToBlack2ToBordeaux: string;
  gradientCardStatsWrestler: string;
}

const colors: Colors = {
  bgColorBlack: 'rgb(26, 26, 25)',
  bgColorBordeaux: 'rgb(163, 27, 27)',
  bgColorRed: 'rgba(219,20,20,1)',
  bgColorBlack2: 'rgb(31, 31, 31)',
  bgColorLight: 'rgb(248, 248, 248)',
  bgSfondoColor: 'rgb(44, 44, 44)',
  bgGradientSfondoColor:
    'linear-gradient(160deg, rgb(45, 45, 45) 0%, rgb(100, 22, 22) 45%, rgb(35, 10, 10) 100%)',
  bgColorSfondoWinner: 'rgb(139, 233, 72)',
  gradientBordeauxToBlack2:
    'linear-gradient(180deg, rgb(163, 27, 27) 85%, rgb(31, 31, 31) 100%)',
  gradientWhiteToBlack2ToBordeaux:
    'linear-gradient(180deg, rgb(31, 31, 31) 5%, rgb(182, 179, 179) 15%, rgb(31, 31, 31) 30%, rgb(163, 27, 27) 75%, rgb(182, 179, 179) 90%, rgb(31, 31, 31) 100%)',
  gradientCardStatsWrestler:
    'linear-gradient(180deg,rgba(145, 47, 25, 1) 0%, rgba(110, 3, 3, 1) 49%, rgba(26, 2, 2, 1) 94%)',
};

export default colors;
